import { Box, styled } from '@mui/material';


export const IconWrapper = styled(Box)(({theme}) => ({
    position: 'relative',
    cursor: 'pointer',
    'span': {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 4,
        textAlign: 'center',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        textShadow: '1px 1px 0px white, -1px -1px 0px white',
    }
}));
